import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const HeroIntro: React.FC = () => (
  <Box sx={{ textAlign: 'center', py: { xs: 4, md: 6 }, px: 2 }}>
    <Typography variant="h3" component="h1" sx={{ fontWeight: 700, mb: 2 }}>
      Discover Your Style with Hooliah
    </Typography>
    <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto', mb: 3 }}>
      Upload your outfits, get AI-powered style analysis, and connect with a community of fashion enthusiasts who share your passion.
    </Typography>
    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
      <Button variant="contained" size="large" component={RouterLink} to="/upload">
        Upload Your Outfit
      </Button>
      <Button variant="outlined" size="large" component={RouterLink} to="/blog">
        Read the Blog
      </Button>
    </Box>
  </Box>
);

export default HeroIntro;
